<script>
	export let row = {};
	export let key = "";
	export let options = "";

	$: status = row[key];

	let damageStatuses = {
		NoNewDamage: `<p class="status-bar status-bar-7">No New Damage</p>`,
		NoDamage: `<p class="status-bar status-bar-9">No Damage</p>`,
	};

	let statusComponents = {
		damages: damageStatuses,
	};
</script>

{@html statusComponents[options][status]}
